import { Folder } from "./SpotSchema";
import { FolderClosed, File } from "lucide-react";
type FolderProps<T> = {
  source: Folder
  expandedList: string[] | null;
  onChange: (value: string | number, file: string|null) => void;
  className?: string;
};

export function FolderComp<T>({
  source,
  expandedList,
  onChange,
  className = ""
}: FolderProps<T>) {
  

  return (
    <div>    <div className="cursor-pointer" onClick={()=>onChange(source.id, null)}>
      <FolderClosed color="orange" className="inline-block mr-1 "/>{source.name}</div>
    {source.children.length > 0 && expandedList && (( expandedList.find(s=>s == source.id)?.length??0) > 0) && (
      <div className="ml-4">
        {source.children.map((child, childIndex) => (
          <FolderComp 
            key={childIndex}    
            source={child}
            expandedList={expandedList}
            onChange={onChange}
          />
        ))  }   
        </div>
    )}
    {source.files.length > 0 && expandedList && (( expandedList.find(s=>s == source.id)?.length??0) > 0) && (
      <div className="ml-4">
        {source.files.map((child, childIndex) => (
          <div className="cursor-pointer" onClick={()=>onChange(source.id, source.fullName + "\\" + child)}><File color="black" className="inline-block mr-1  "/>{child}</div>
        ))  }   
        </div>
    )}

    </div>

  )
  
}
